<div class="dropdown" clickOrKeyupOutside (clickOutsideEmitter)="clickedOutside()" (KeyupOutsideEmitter)="tabbedOutside()">
  <button class="dropbtn" (click)="toggleDropdown()" id="menu-button" aria-haspopup="true" attr.aria-expanded="{{showMenu}}">{{ username }}<app-lu-icon icon="chevron-down" class="menu-icon"></app-lu-icon></button>
  <ul [class.show-dropdown]="showMenu" class="dropdown-content" id="drop-down-menu" aria-labelledby="menu-button">
    @for (option of menuOptions; track option) {
      <li>
        @if (option.action && option.isVisible && option.isVisible()) {
          <button (click)="option.action()">
            <app-lu-icon icon={{option.icon}}></app-lu-icon>
            {{option.optionText}}
          </button>
        }
        @if (option.external === true) {
          <a tabindex="0" href="{{option.path}}">{{option.optionText}}</a>
        }
        @if (option.external === undefined && option.path) {
          <a tabindex="0" href="#" [routerLink]="option.path">{{option.optionText}}</a>
        }
      </li>
    }
  </ul>
</div>